var _a, _b, _c, _d;
import { BASIC_ANCILLARY_CODES_MILES, BASIC_ANCILLARY_CODES_HAND_BAGGAGE, BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE, BASIC_ANCILLARY_CODES_SEAT_RESERVATION, BASIC_ANCILLARY_CODES_MEALS, BASIC_ANCILLARY_CODES_PREMIUM_BOARDING, BASIC_ANCILLARY_CODES_FASTTRACK, BASIC_ANCILLARY_CODES_FLIGHT_CHANGES, BASIC_ANCILLARY_CODES_FLIGHT_REFUNDS, BASIC_ANCILLARY_CODES_PREMIUM_CHECKIN, BASIC_ANCILLARY_CODES_PREMIUM_CUSTOMER_CENTER, BASIC_ANCILLARY_CODES_LOUNGE, BASIC_ANCILLARY_CODES_KIOSK, BASIC_ANCILLARY_CODES_PRIORITY_BAGGAGE, BASIC_ANCILLARY_CODES_PREMIUM_BAGGAGE, BASIC_ANCILLARY_CODES_FLIGHT_CANCELLATION, SSR_CODE_KIOSK, SSR_CODE_KIOSK_X2, SSR_CODE_KIOSK_X3, SSR_CODE_KIOSK_X7, SSR_CODE_HAND_BAGGAGE, SSR_CODE_HAND_BAGGAGE_10, SSR_CODE_HAND_BAGGAGE_X2, SSR_CODE_HAND_BAGGAGE_10x2, SSR_CODE_PERSONAL_ITEM, SSR_CODE_BAGGAGE_FIRST_BAG, SSR_CODE_BAGGAGE_SECOND_BAG, SSR_CODE_BAGGAGE_ADDITIONAL_BAG, SSR_CODE_BAGGAGE_FIRST_BAG_X2, SSR_CODE_BAGGAGE_FIRST_BAG_X3, SSR_CODE_BAGGAGE_32_BAG_X2, SSR_CODE_BAGGAGE_32_BAG_X3, BRAND_CODE_EXECUTIVE, BRAND_CODE_TOP_EXECUTIVE, BRAND_CODE_AWARD_EXECUTIVE, FLIGHT_HAUL_TYPE_LONG, BASIC_ANCILLARY_CODES_SNACK } from '@ibe.config';
var Brand = /** @class */ (function () {
    function Brand() {
    }
    return Brand;
}());
export { Brand };
;
;
var HAND_BAGGAGE = {
    id: 'bags',
    label: 'Hand baggage',
    labelTranslationKey: 'ancillaries.group.HANDB',
    order: 3,
    type: 'added',
    description: '',
    icon: 'luggage--cabin_trolley',
    details: { label: 'Learn more', route: 'details-hand_luggage' },
    flight_details: { label: 'Learn more', route: 'flight-details-hand_luggage' },
    specificAncillaryLabels: (_a = {},
        _a[SSR_CODE_HAND_BAGGAGE] = 'ancillaries.description.HANDB',
        _a[SSR_CODE_HAND_BAGGAGE_10] = 'ancillaries.description.HANDB10',
        _a[SSR_CODE_HAND_BAGGAGE_X2] = 'ancillaries.description.HANDBx2',
        _a[SSR_CODE_HAND_BAGGAGE_10x2] = 'ancillaries.description.HANDB10x2',
        _a[SSR_CODE_PERSONAL_ITEM] = 'ancillaries.description.PITEM',
        _a),
    toolTip: 'whatsIncludedSidebars.detailsHandLuggage.tooltip.maxWeightPerBagTooltip' + ' ' + 'whatsIncludedSidebars.detailsHandLuggage.text.baggageAllowance8kg'
};
// ---------------------------------------- [ EXTRA BAGGAGE ]
var EXTRA_BAGGAGE = {
    name: 'Checked bags',
    id: 'bags',
    label: 'Extra bags',
    description: 'From 47,00 EUR',
    type: 'extra',
    price: 47,
    secondary: false,
    secondary_on_mobile: false,
    action: { label: 'add', route: 'checked-bags' },
    icon: 'ancillaries--luggage'
};
var DIGITAL_KIOSK = {
    id: 'kiosk',
    label: 'Digital Kiosk',
    labelTranslationKey: 'ancillaries.group.KIOSK',
    type: 'added',
    description: '',
    details: { label: 'Learn more', route: 'details-kiosk' },
    flight_details: { label: 'Learn more', route: '' },
    icon: 'leisure_and_commodities--magazines',
    specificAncillaryLabels: (_b = {},
        _b[SSR_CODE_KIOSK] = 'ancillaries.description.KIOSK',
        _b[SSR_CODE_KIOSK_X2] = 'ancillaries.description.KIOSKx2',
        _b[SSR_CODE_KIOSK_X3] = 'ancillaries.description.KIOSKx3',
        _b[SSR_CODE_KIOSK_X7] = 'ancillaries.description.KIOSKx7',
        _b)
};
var SPORTS_EQUIPMENT = {
    id: 'sports',
    label: 'Sports Equipment',
    labelTranslationKey: 'ancillaries.group.SPEQ',
    description: '',
    type: 'added',
    details: { label: 'Learn more', route: 'sports-equipment' },
    flight_details: { label: 'Learn more', route: '' },
    icon: 'ancillaries--sports_equipment'
};
var MUSICAL_EQUIPMENT = {
    id: 'instruments',
    label: 'Musical Equipment',
    labelTranslationKey: 'ancillaries.group.musicalEquipment',
    description: '',
    type: 'added',
    details: { label: 'Learn more', route: 'musical-equipment' },
    flight_details: { label: 'Learn more', route: '' },
    icon: 'luggage--music_equipment'
};
var PREMIUM_CUSTOMER_CENTRE = {
    id: 'premium-customer-centre',
    label: 'Premium Customer Centre',
    labelTranslationKey: 'ancillaries.group.PCENTER',
    type: 'added',
    order: 9,
    description: '',
    details: { label: 'Learn more', route: 'premium-customer-centre' },
    icon: 'support--premium_customer_service',
    flight_details: { label: 'Learn more', route: 'flight-details-premium-customer-centre' }
};
var PREMIUM_BOARDING = {
    id: 'differentiated-boarding',
    label: 'Premium Boarding',
    labelTranslationKey: 'ancillaries.group.premiumBoarding',
    type: 'added',
    order: 10,
    description: '',
    details: { label: 'Learn more', route: 'premium-boarding' },
    icon: 'airport--differentiated_boarding',
    flight_details: { label: 'Learn more', route: 'flight-details-differentiated_boarding' },
    toolTip: 'whatsIncludedSidebars.general.title.includedPerPassenger'
};
var PRIORITY_BAGGAGE = {
    id: 'priority-baggage',
    label: 'Priority Baggage',
    labelTranslationKey: 'ancillaries.group.PBAGG',
    type: 'added',
    order: 10,
    description: '',
    icon: 'luggage--priority',
    details: { label: 'Learn more', route: 'details-priority-luggage' },
    flight_details: { label: 'Learn more', route: 'flight-details-priority-luggage' }
};
var PREMIUM_BAGGAGE = {
    id: 'differentiated-boarding',
    label: 'Premium Baggage',
    labelTranslationKey: 'ancillaries.group.premiumBaggage',
    type: 'added',
    order: 10,
    description: '',
    details: { label: 'Learn more', route: '' },
    icon: 'airport--differentiated_boarding',
    flight_details: { label: 'Learn more', route: '' }
};
var PRIORITY_CHECK_IN = {
    id: 'priority-checkin',
    label: 'Priority Check-In',
    labelTranslationKey: 'ancillaries.group.PCHECK',
    type: 'added',
    order: 11,
    description: '',
    details: { label: 'Learn more', route: 'priority-checkin' },
    icon: 'check-in--priority',
    flight_details: { label: 'Learn more', route: 'flight-details-priority-checkin' },
    toolTip: 'whatsIncludedSidebars.detailsPriorityCheckin.title.checkinPerPassenger'
};
var PETS = {
    id: 'pets',
    label: 'Pets',
    labelTranslationKey: '',
    description: '',
    type: 'added',
    details: { label: 'Learn more', route: 'pets' },
    icon: 'luggage--small_pets'
};
var CHECKED_BAGGAGE = {
    id: 'checked-baggage',
    label: 'Checked baggage',
    labelTranslationKey: 'ancillaries.group.FBAG',
    order: 4,
    description: '',
    type: 'added',
    icon: 'ancillaries--luggage',
    details: { label: 'Learn more', route: 'details-luggage' },
    flight_details: { label: 'Learn more', route: 'flight-details-luggage' },
    specificAncillaryLabels: (_c = {},
        _c[SSR_CODE_BAGGAGE_FIRST_BAG] = 'ancillaries.description.FBAG',
        _c[SSR_CODE_BAGGAGE_SECOND_BAG] = 'ancillaries.description.SBAG',
        _c[SSR_CODE_BAGGAGE_ADDITIONAL_BAG] = 'ancillaries.description.XBAG',
        _c[SSR_CODE_BAGGAGE_FIRST_BAG_X2] = 'ancillaries.description.FBAGx2',
        _c[SSR_CODE_BAGGAGE_FIRST_BAG_X3] = 'ancillaries.description.FBAGx3',
        _c[SSR_CODE_BAGGAGE_32_BAG_X2] = 'ancillaries.description.32BAGx2',
        _c[SSR_CODE_BAGGAGE_32_BAG_X3] = 'ancillaries.description.32BAGx3',
        _c),
    toolTip: 'whatsIncludedSidebars.detailsHandLuggage.title.maxWeightPerBag' + ' ' + 'whatsIncludedSidebars.detailsLuggage.texts.maxWeightSpecs'
};
var DETAILS_LOUNGE = {
    id: 'lounge',
    label: 'Lounge access',
    labelTranslationKey: 'ancillaries.group.LOUNGE',
    description: 'ancillaries.description.LOUNGE',
    type: 'added',
    order: 7,
    details: { label: 'Learn more', route: 'details-lounge' },
    icon: 'ancillaries--lounge',
    flight_details: { label: 'Learn more', route: 'flight-details-lounge' },
    toolTip: 'priceBreakdown.ancillaries.text.detailsLounge'
};
// ---------------------------------------- [ EXTRA BAGGAGE ]
var EXTRA_BAGGAGE_BEF = {
    name: 'Checked bags',
    id: 'bags',
    label: 'Extra bags',
    description: 'From 47,00 EUR',
    type: 'extra',
    price: 47,
    secondary: false,
    secondary_on_mobile: false,
    action: { label: 'add', route: 'checked-bags' },
    icon: 'ancillaries--luggage'
};
var MILES = {
    id: 'miles',
    label: 'Miles',
    labelTranslationKey: 'ancillaries.group.miles',
    order: 2,
    description: 'Miles',
    type: 'added',
    details: { label: 'Learn more', route: 'details-loyalty_miles' },
    icon: 'loyalty--miles',
    flight_details: { label: 'Learn more', route: 'flight-details-miles' },
    toolTip: 'whatsIncludedSidebars.general.title.includedPerPassenger'
};
var SEATS = {
    id: 'seats',
    label: 'Seat reservation',
    labelTranslationKey: 'ancillaries.group.RQST',
    order: 4,
    description: '',
    type: 'available',
    details: { label: 'Learn more', route: 'details-seat' },
    flight_details: { label: 'Learn more', route: 'flight-details-seat' },
    icon: 'plane_related--seat',
    price: 35,
    toolTip: 'bookingDetails.text.freeSeatInStandardArea'
};
var SNACKS = {
    id: 'meals',
    label: 'Meal',
    labelTranslationKey: 'ancillaries.group.SNACKS',
    order: 5,
    description: 'ancillaries.description.SNACKS',
    type: 'available',
    icon: 'food_drinks--cold_meals',
    details: { label: 'Learn more', route: 'details-snacks' },
    flight_details: { label: 'Learn more', route: 'flight-details-snacks' },
    toolTip: 'Search.label.mealsIncluded'
};
var MEALS = {
    id: 'meals',
    label: 'Meal',
    labelTranslationKey: 'ancillaries.group.MEAL',
    order: 5,
    description: 'ancillaries.description.MEAL',
    type: 'added',
    icon: 'food_drinks--cold_meals',
    details: { label: 'Learn more', route: 'details-snacks' },
    flight_details: { label: 'Learn more', route: 'flight-details-meals' },
    toolTip: 'Search.label.mealsIncluded'
};
var FASTTRACK = {
    id: 'fasttrack',
    label: 'Fast track',
    labelTranslationKey: 'ancillaries.group.FAST',
    icon: 'plane_related--fast_track',
    type: 'available',
    description: 'ancillaries.description.FAST',
    order: 7,
    price: 10,
    details: { label: 'Learn more', route: '' },
    flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
    toolTip: 'whatsIncludedSidebars.detailsFastTrack.title.fastTrackPerPassenger'
};
var REFUNDS = {
    id: 'refunds',
    label: 'Refundable',
    labelTranslationKey: 'ancillaries.group.refund',
    description: '',
    type: 'available',
    icon: 'money_related--refund',
    price: 100,
    order: 99,
    flight_details: { label: 'Learn more', route: 'flight-details-refunds' },
    toolTip: 'ancillaries.group.refund'
};
var CHANGES = {
    id: 'changes',
    label: 'changes',
    labelTranslationKey: 'ancillaries.group.CHANGES',
    description: '',
    icon: 'airport--changes',
    type: 'available',
    price: 100,
    order: 8,
    details: { label: 'Learn more', route: '' },
    flight_details: { label: 'Learn more', route: 'flight-details-changes' },
    toolTip: 'ancillaries.group.CHANGESFree'
};
var CANCELLATIONS = {
    id: 'refunds',
    label: 'Refundable',
    labelTranslationKey: 'ancillaries.group.refund',
    description: '',
    type: 'available',
    icon: 'money_related--refund',
    price: 100,
    order: 99,
    details: { label: 'Learn more', route: '' },
    flight_details: { label: 'Learn more', route: '' }
};
var CHECKED_BAGGAGE_DETAILS = (_d = {},
    _d[SSR_CODE_BAGGAGE_FIRST_BAG] = { completeDescription: 'ancillaries.detailed.FBAG', countMultiplier: '1 x', count: '1', weight: '23Kg' },
    _d[SSR_CODE_BAGGAGE_SECOND_BAG] = { completeDescription: 'ancillaries.detailed.SBAG', countMultiplier: '1 x', count: '1', weight: '23Kg' },
    _d[SSR_CODE_BAGGAGE_ADDITIONAL_BAG] = { completeDescription: 'ancillaries.detailed.XBAG', countMultiplier: '', count: '1', weight: '' },
    _d[SSR_CODE_BAGGAGE_FIRST_BAG_X2] = { completeDescription: 'ancillaries.detailed.FBAGx2', countMultiplier: '2 x', count: '2', weight: '23Kg' },
    _d[SSR_CODE_BAGGAGE_FIRST_BAG_X3] = { completeDescription: 'ancillaries.detailed.FBAGx3', countMultiplier: '3 x', count: '3', weight: '23Kg' },
    _d[SSR_CODE_BAGGAGE_32_BAG_X2] = { completeDescription: 'ancillaries.detailed.32BAGx2', countMultiplier: '2 x', count: '2', weight: '32Kg' },
    _d[SSR_CODE_BAGGAGE_32_BAG_X3] = { completeDescription: 'ancillaries.detailed.32BAGx3', countMultiplier: '3 x', count: '3', weight: '32Kg' },
    _d);
var NO_PREMIUM_FEATURES = [
    {
        label: 'Premium Customer Centre',
        type: 'unavailable',
        order: 9,
        icon: 'support--premium_customer_service',
        flight_details: { label: 'Learn more', route: 'flight-details-premium-customer-centre' },
        id: 'premium-customer-centre'
    },
    {
        label: 'Premium Boarding',
        type: 'unavailable',
        order: 10,
        icon: 'airport--differentiated_boarding',
        flight_details: { label: 'Learn more', route: 'flight-details-differentiated_boarding' },
        id: 'differentiated-boarding'
    },
    {
        label: 'Priority Check In',
        type: 'unavailable',
        order: 11,
        icon: 'check-in--priority',
        flight_details: { label: 'Learn more', route: 'flight-details-priority-checkin' },
        id: 'priority-checkin'
    }
];
var DETAILS_NO_LOUNGE = {
    label: 'Lounge access',
    type: 'available',
    description: 'from 25€',
    price: 25,
    order: 7,
    id: 'lounge',
    icon: 'ancillaries--lounge',
    flight_details: { label: 'Learn more', route: 'flight-details-lounge' }
};
export var PASSENGER_INCLUDED_EXTRAS = [
    DIGITAL_KIOSK,
    PETS,
    SPORTS_EQUIPMENT,
    MUSICAL_EQUIPMENT
];
// export const WIFI_ONBOARD_FEATURE = WIFI_BF;
// export const AUTOMATIC_CHECKIN_FEATURE = AUTOMATIC_CHECKIN_BF;
export var PASSENGER_INCLUDED_LINKS = [
    DIGITAL_KIOSK,
    PETS,
    SPORTS_EQUIPMENT,
    MUSICAL_EQUIPMENT,
    {
        label: 'José Simões is a GOLD Member',
        cssClass: 'hide-on-print',
        description: '',
        type: 'added',
        secondary: false,
        secondary_on_mobile: false,
        icon: null,
        included: { label: 'View all benefits' }
    },
    {
        label: '',
        cssClass: 'hide-on-print',
        description: '',
        type: 'added',
        secondary: false,
        secondary_on_mobile: false,
        icon: null,
        included: {
            label: 'See what′s included per passenger'
        }
    }
];
export var DEFAULT_FEATURES = [
    {
        label: 'Miles',
        order: 2,
        description: 'For Miles&GO members only',
        type: 'added',
        details: { label: 'Learn more', route: 'details-loyalty_miles' },
        icon: 'loyalty--miles',
        flight_details: { label: 'Learn more', route: 'flight-details-miles' },
        id: 'miles'
    },
    HAND_BAGGAGE,
    {
        label: 'Meal',
        description: 'May include dairy and other allergens',
        type: 'added',
        icon: 'ancillaries--meals',
        details: { label: 'Learn more', route: 'details-meals' }
    },
];
export var ECONOMY_EXTRAS_SECONDARY_FEATURES = [
    {
        label: 'Lounge from 15,00€',
        description: 'from 15€',
        type: 'extra',
        price: 15,
        secondary: false,
        secondary_on_mobile: true,
        action: { label: 'add', route: 'ancillaries--lounge' },
        icon: 'ancillaries--lounge',
        name: 'Lounge',
        id: 'lounge'
    }, {
        label: 'Sports equipment from 20,00€',
        description: 'From 20,00€',
        type: 'extra',
        price: 20,
        secondary: true,
        secondary_on_mobile: true,
        action: { label: 'Choose', route: 'ancillaries--sports_equipment' },
        icon: 'ancillaries--sports_equipment',
        name: 'Sports equipments',
        id: 'sports'
    },
    {
        label: 'Music instruments from 20,00€',
        description: 'From 20,00€',
        type: 'extra',
        price: 20,
        secondary: true,
        secondary_on_mobile: true,
        action: { label: 'Choose', route: 'ancillaries--music-instruments' },
        icon: 'luggage--music_equipment',
        name: 'Music instruments',
        id: 'instruments'
    },
    {
        label: 'Small pets from 35,00€',
        description: 'From 35,00€',
        type: 'extra',
        price: 35,
        secondary: true,
        secondary_on_mobile: true,
        action: { label: 'Choose', route: 'ancillaries--small-pets' },
        icon: 'luggage--small_pets',
        name: 'Small pets',
        id: 'pets'
    },
    {
        label: 'Special meals for free',
        description: 'Free for people with food restrictions',
        type: 'extra',
        price: 0,
        secondary: true,
        secondary_on_mobile: true,
        action: { label: 'choose', route: 'ancillaries--special-meals' },
        icon: 'ancillaries--special_meals',
        name: 'meals',
        id: 'meals'
    }
];
export var BUSINESS_EXTRAS_SECONDARY_FEATURES = [
    {
        label: 'Sports equipment from 20,00€',
        description: 'From 20,00€',
        type: 'extra',
        price: 20,
        secondary: true,
        secondary_on_mobile: true,
        action: { label: 'Choose', route: 'ancillaries--sports_equipment' },
        icon: 'ancillaries--sports_equipment',
        name: 'Sports equipments',
        id: 'sports'
    },
    {
        label: 'Music instruments from 20,00€',
        description: 'From 20,00€',
        type: 'extra',
        price: 20,
        secondary: true,
        secondary_on_mobile: true,
        action: { label: 'Choose', route: 'ancillaries--music-instruments' },
        icon: 'luggage--music_equipment',
        name: 'Music instruments',
        id: 'instruments'
    },
    {
        label: 'Small pets from 35,00€',
        description: 'From 35,00€',
        type: 'extra',
        price: 35,
        secondary: true,
        secondary_on_mobile: true,
        action: { label: 'Choose', route: 'ancillaries--small-pets' },
        icon: 'luggage--small_pets',
        name: 'Small pets',
        id: 'pets'
    }
];
export var DISCOUNT_FEATURES = [
    {
        label: 'Miles',
        order: 1,
        description: 'For Miles&GO members only',
        type: 'added',
        details: { label: 'Learn more', route: 'details-loyalty_miles' },
        icon: 'loyalty--miles',
        flight_details: { label: 'Learn more', route: 'flight-details-miles' },
        id: 'miles'
    },
    HAND_BAGGAGE,
    {
        id: 'checked-baggage',
        label: 'Checked baggage',
        order: 3,
        icon: 'ancillaries--luggage',
        flight_details: { label: 'Learn more', route: 'flight-details-luggage' },
        type: 'available',
        price: 35
    },
    {
        label: 'Seat reservation',
        order: 4,
        description: '12B',
        id: 'seats',
        type: 'available',
        details: { label: 'Learn more', route: 'details-seat' },
        flight_details: { label: 'Learn more', route: 'flight-details-seat' },
        icon: 'plane_related--seat',
        price: 35
    },
    {
        id: 'meals',
        label: 'Meal',
        order: 5,
        description: 'Meal not included',
        type: 'unavailable',
        details: { label: 'Learn more', route: 'details-snacks' },
        flight_details: { label: 'Learn more', route: 'flight-details-snacks' },
        icon: 'food_drinks--cold_meals'
    },
    {
        label: 'Premium Boarding',
        type: 'unavailable',
        order: 6,
        details: { label: 'Learn more', route: 'premium-boarding' },
        icon: 'airport--differentiated_boarding',
        flight_details: { label: 'Learn more', route: 'flight-details-differentiated_boarding' },
        id: 'differentiated-boarding'
    },
    {
        label: 'Fast track',
        icon: 'plane_related--fast_track',
        type: 'available',
        description: 'All passengers can get faster through security',
        flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
        id: 'fasttrack',
        order: 7,
        price: 12
    },
    {
        label: 'Changes',
        icon: 'airport--changes',
        type: 'unavailable',
        id: 'changes',
        order: 8,
        flight_details: { label: 'Learn more', route: 'flight-details-changes' },
    },
    {
        label: 'Choose a seating area from 12,00€',
        description: 'Seats from 12€',
        type: 'extra',
        price: 12,
        secondary: false,
        secondary_on_mobile: false,
        icon: 'plane_related--seat',
        action: { label: 'Choose', route: 'seatmap' },
        name: 'Seats',
        id: 'seats'
    },
    {
        label: 'Extra bags from 12,00€',
        description: 'from 22€',
        type: 'extra',
        price: 22,
        secondary: false,
        secondary_on_mobile: false,
        icon: 'ancillaries--luggage',
        action: { label: 'add', route: 'checked-bags' },
        name: 'Checked bags',
        id: 'bags'
    },
    {
        label: 'Fast track from 12,00€',
        description: 'from 12€',
        type: 'extra',
        price: 12,
        secondary: false,
        secondary_on_mobile: true,
        icon: 'plane_related--fast_track',
        action: { label: 'add', route: 'fast-track' },
        name: 'Fast track',
        id: 'fasttrack'
    },
    Object.assign({}, PRIORITY_BAGGAGE, { type: 'unavailable' }),
    // ...NO_PREMIUM_FEATURES,
    {
        label: 'Refundable',
        icon: 'money_related--refund',
        type: 'unavailable',
        id: 'refunds',
        order: 99,
        flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
    }
].concat(ECONOMY_EXTRAS_SECONDARY_FEATURES);
export var BASIC_FEATURES = [
    {
        label: 'Miles',
        order: 1,
        description: 'For Miles&GO members only',
        type: 'added',
        icon: 'loyalty--miles',
        details: { label: 'Learn more', route: 'details-loyalty_miles' },
        flight_details: { label: 'Learn more', route: 'flight-details-miles' },
        id: 'miles'
    },
    HAND_BAGGAGE,
    Object.assign({}, CHECKED_BAGGAGE, { amount: 1 }),
    {
        label: 'Seat reservation',
        order: 4,
        description: '12B',
        id: 'seats',
        type: 'available',
        icon: 'plane_related--seat',
        details: { label: 'Learn more', route: 'details-seat' },
        flight_details: { label: 'Learn more', route: 'flight-details-seat' },
        price: 35
    },
    {
        label: 'Meal',
        order: 5,
        description: 'May include dairy and other allergens',
        id: 'meals',
        type: 'unavailable',
        icon: 'food_drinks--cold_meals',
        details: { label: 'Learn more', route: 'details-snacks' },
        flight_details: { label: 'Learn more', route: 'flight-details-snacks' }
    },
    {
        label: 'Premium Boarding',
        type: 'unavailable',
        order: 6,
        details: { label: 'Learn more', route: 'premium-boarding' },
        icon: 'airport--differentiated_boarding',
        flight_details: { label: 'Learn more', route: 'flight-details-differentiated_boarding' },
        id: 'differentiated-boarding'
    },
    {
        label: 'Fast track',
        icon: 'plane_related--fast_track',
        description: 'All passengers can get faster through security',
        id: 'fasttrack',
        order: 7,
        flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
        type: 'available',
        price: 10
    },
    {
        label: 'Changes',
        icon: 'airport--changes',
        type: 'available',
        price: 100,
        id: 'changes',
        order: 8,
        flight_details: { label: 'Learn more', route: 'flight-details-changes' },
    },
    {
        label: 'Choose a seating area from 12,00€',
        description: 'Seats from 12€',
        type: 'extra',
        price: 12,
        secondary: false,
        secondary_on_mobile: false,
        action: { label: 'Choose', route: 'seatmap' },
        icon: 'plane_related--seat',
        name: 'Seats',
        id: 'seats'
    },
    {
        label: 'Extra bags from 12,00€',
        description: 'from 12€',
        type: 'extra',
        price: 12,
        secondary: false,
        secondary_on_mobile: false,
        action: { label: 'add', route: 'checked-bags' },
        icon: 'ancillaries--luggage',
        name: 'Checked bags',
        id: 'bags'
    },
    {
        label: 'Fast track from 12,00€',
        description: 'from 12€',
        type: 'extra',
        price: 12,
        secondary: false,
        secondary_on_mobile: true,
        action: { label: 'add', route: 'fast-track' },
        icon: 'plane_related--fast_track',
        name: 'Fast track',
        id: 'fasttrack'
    },
    Object.assign({}, PRIORITY_BAGGAGE, { type: 'unavailable' }),
    // ...NO_PREMIUM_FEATURES,
    {
        label: 'Refundable',
        icon: 'money_related--refund',
        type: 'unavailable',
        id: 'refunds',
        order: 99,
        flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
    }
].concat(ECONOMY_EXTRAS_SECONDARY_FEATURES);
export var CLASSIC_FEATURES = [
    {
        label: 'Miles',
        order: 1,
        description: 'For Miles&GO members only',
        type: 'added',
        icon: 'loyalty--miles',
        details: { label: 'Learn more', route: 'details-loyalty_miles' },
        flight_details: { label: 'Learn more', route: 'flight-details-miles' },
        id: 'miles'
    },
    HAND_BAGGAGE,
    Object.assign({}, CHECKED_BAGGAGE, { amount: 1 }),
    {
        label: 'Standard seat reservation',
        order: 4,
        description: 'Free seat reservation in standard area',
        id: 'seats',
        type: 'added',
        icon: 'plane_related--seat',
        details: { label: 'Learn more', route: 'details-seat' },
        flight_details: { label: 'Learn more', route: 'flight-details-seat' }
    },
    {
        label: 'Meal',
        order: 5,
        description: 'For free. May include dairy and other allergens',
        id: 'meals',
        type: 'added',
        icon: 'food_drinks--cold_meals',
        details: { label: 'Learn more', route: 'details-snacks' },
        flight_details: { label: 'Learn more', route: 'flight-details-meals' }
    },
    {
        label: 'Premium Boarding',
        type: 'added',
        order: 6,
        details: { label: 'Learn more', route: 'premium-boarding' },
        icon: 'airport--differentiated_boarding',
        flight_details: { label: 'Learn more', route: 'flight-details-differentiated_boarding' },
        id: 'differentiated-boarding'
    },
    {
        label: 'Fast track',
        icon: 'plane_related--fast_track',
        type: 'available',
        description: 'All passengers can get faster through security',
        id: 'fasttrack',
        order: 8,
        flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
        price: 10
    },
    {
        label: 'Changes',
        icon: 'airport--changes',
        type: 'available',
        price: 35,
        id: 'changes',
        order: 9,
        flight_details: { label: 'Learn more', route: 'flight-details-changes' },
    },
    {
        label: 'Choose a seating area',
        description: 'Seats from 0€',
        type: 'extra',
        price: 0,
        secondary: false,
        secondary_on_mobile: false,
        action: { label: 'Choose', route: 'seatmap' },
        icon: 'plane_related--seat',
        name: 'Seats',
        id: 'seats'
    },
    {
        label: 'Extra bags from 12,00€',
        description: 'from 20€',
        type: 'extra',
        price: 20,
        secondary: false,
        secondary_on_mobile: false,
        action: { label: 'add', route: 'checked-bags' },
        icon: 'ancillaries--luggage',
        name: 'Checked bags',
        id: 'bags'
    },
    {
        label: 'Fast track from 12,00€',
        description: 'from 12€',
        type: 'extra',
        price: 12,
        secondary: false,
        secondary_on_mobile: true,
        action: { label: 'add', route: 'fast-track' },
        icon: 'plane_related--fast_track',
        name: 'Fast track',
        id: 'fasttrack'
    },
    // ...NO_PREMIUM_FEATURES,
    {
        label: 'Refundable',
        icon: 'money_related--refund',
        type: 'unavailable',
        id: 'refunds',
        order: 99,
        flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
    }
].concat(ECONOMY_EXTRAS_SECONDARY_FEATURES);
export var PLUS_FEATURES = [
    {
        label: 'Miles',
        order: 1,
        description: 'For Miles&GO members only',
        type: 'added',
        icon: 'loyalty--miles',
        details: { label: 'Learn more', route: 'details-loyalty_miles' },
        flight_details: { label: 'Learn more', route: 'flight-details-miles' },
        id: 'miles'
    },
    HAND_BAGGAGE,
    Object.assign({}, CHECKED_BAGGAGE, { amount: 2 }),
    {
        label: 'Free seat reservation',
        order: 4,
        description: 'In standard and preferred areas',
        id: 'seats',
        type: 'added',
        icon: 'plane_related--seat',
        details: { label: 'Learn more', route: 'details-seat' },
        flight_details: { label: 'Learn more', route: 'flight-details-seat' }
    },
    {
        label: 'Meal',
        order: 5,
        description: 'For free. May include dairy and other allergens',
        id: 'meals',
        type: 'added',
        icon: 'food_drinks--cold_meals',
        details: { label: 'Learn more', route: 'details-snacks' },
        flight_details: { label: 'Learn more', route: 'flight-details-meals' }
    },
    {
        label: 'Premium Boarding',
        type: 'added',
        order: 6,
        details: { label: 'Learn more', route: 'premium-boarding' },
        icon: 'airport--differentiated_boarding',
        flight_details: { label: 'Learn more', route: 'flight-details-differentiated_boarding' },
        id: 'differentiated-boarding'
    },
    {
        label: 'Fast track',
        description: 'All passengers can get faster through security',
        id: 'fasttrack',
        order: 7,
        type: 'added',
        flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
        icon: 'plane_related--fast_track',
        details: { label: 'Learn more', route: 'details-fast_track' }
    },
    {
        label: 'Free changes',
        description: 'Schedule or date changes allowed',
        type: 'added',
        icon: 'airport--changes',
        details: { label: 'Learn more', route: 'details-changes' },
        id: 'changes',
        order: 8,
        flight_details: { label: 'Learn more', route: 'flight-details-changes' },
    },
    {
        label: 'Choose a seating area from 0€',
        description: 'Seats from 0€',
        type: 'extra',
        price: 0,
        secondary: false,
        secondary_on_mobile: false,
        action: { label: 'Choose', route: 'seatmap' },
        icon: 'plane_related--seat',
        name: 'Seats',
        id: 'seats'
    },
    {
        label: 'Extra bags from 20,00€',
        description: 'From 20,00€',
        type: 'extra',
        price: 20,
        secondary: false,
        secondary_on_mobile: false,
        action: { label: 'add', route: 'checked-bags' },
        icon: 'ancillaries--luggage',
        name: 'Checked bags',
        id: 'bags'
    },
    {
        label: 'Fast track from 12,00€',
        description: 'from 12€',
        type: 'extra',
        price: 12,
        secondary: true,
        secondary_on_mobile: true,
        action: { label: 'add', route: 'fast-track' },
        icon: 'plane_related--fast_track',
        name: 'Fast track',
        id: 'fasttrack'
    },
    PRIORITY_BAGGAGE,
    // ...NO_PREMIUM_FEATURES,
    {
        label: 'Refundable',
        icon: 'money_related--refund',
        type: 'available',
        price: 10,
        id: 'refunds',
        order: 99,
        flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
    }
].concat(ECONOMY_EXTRAS_SECONDARY_FEATURES);
export var EXECUTIVE_FEATURES = [
    {
        label: 'Miles',
        order: 1,
        description: 'For Miles&GO members only',
        type: 'added',
        icon: 'loyalty--miles',
        details: { label: 'Learn more', route: 'details-loyalty_miles' },
        flight_details: { label: 'Learn more', route: 'flight-details-miles' },
        id: 'miles'
    },
    HAND_BAGGAGE,
    Object.assign({}, CHECKED_BAGGAGE, { amount: 2 }),
    PRIORITY_BAGGAGE,
    {
        label: 'Free seat reservation',
        description: 'In any area',
        id: 'seats',
        order: 4,
        type: 'added',
        icon: 'plane_related--seat',
        details: { label: 'Learn more', route: 'details-seat' },
        flight_details: { label: 'Learn more', route: 'flight-details-seat' }
    },
    {
        label: 'Meal',
        order: 5,
        description: 'For free. May include dairy and other allergens',
        id: 'meals',
        type: 'added',
        icon: 'food_drinks--cold_meals',
        details: { label: 'Learn more', route: 'details-snacks' },
        flight_details: { label: 'Learn more', route: 'flight-details-meals' }
    },
    {
        label: 'Fast track',
        description: 'All passengers can get faster through security',
        id: 'fasttrack',
        order: 6,
        type: 'added',
        flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
        icon: 'plane_related--fast_track',
        details: { label: 'Learn more', route: 'details-fast_track' }
    },
    {
        label: 'Free changes',
        description: 'Schedule or date changes allowed',
        type: 'added',
        icon: 'airport--changes',
        details: { label: 'Learn more', route: 'details-changes' },
        id: 'changes',
        order: 8,
        flight_details: { label: 'Learn more', route: 'flight-details-changes' },
    },
    {
        label: 'Choose your onboard meal',
        description: 'Choose onboard menu',
        type: 'extra',
        price: 0,
        secondary: false,
        secondary_on_mobile: false,
        action: { label: 'choose', route: 'ancillaries--special-meals' },
        icon: 'ancillaries--special_meals',
        name: 'meals',
        id: 'meals'
    },
    {
        label: 'Choose any seating area for free',
        type: 'extra',
        price: 0,
        secondary: false,
        description: 'Any seat free',
        secondary_on_mobile: false,
        action: { label: 'Choose', route: 'seatmap' },
        icon: 'plane_related--seat',
        name: 'Seats',
        id: 'seats'
    },
    {
        label: 'Extra bags from 47,00€',
        description: 'From 47,00€',
        type: 'extra',
        price: 47,
        secondary: false,
        secondary_on_mobile: false,
        action: { label: 'add', route: 'checked-bags' },
        icon: 'ancillaries--luggage',
        name: 'Checked bags',
        id: 'bags'
    },
    PREMIUM_CUSTOMER_CENTRE,
    PREMIUM_BOARDING,
    PRIORITY_CHECK_IN,
    {
        label: 'Refundable',
        type: 'available',
        icon: 'money_related--refund',
        price: 100,
        id: 'refunds',
        order: 99,
        flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
    }
].concat(BUSINESS_EXTRAS_SECONDARY_FEATURES);
export var TOP_EXECUTIVE_FEATURES = [
    {
        label: 'Miles',
        order: 1,
        description: 'For Miles&GO members only',
        type: 'added',
        icon: 'loyalty--miles',
        details: { label: 'Learn more', route: 'details-loyalty_miles' },
        flight_details: { label: 'Learn more', route: 'flight-details-miles' },
        id: 'miles'
    },
    HAND_BAGGAGE,
    Object.assign({}, CHECKED_BAGGAGE, { amount: 2 }),
    PRIORITY_BAGGAGE,
    {
        label: 'Free seat reservation',
        description: 'In any area',
        id: 'seats',
        order: 4,
        type: 'added',
        icon: 'plane_related--seat',
        details: { label: 'Learn more', route: 'details-seat' },
        flight_details: { label: 'Learn more', route: 'flight-details-seat' }
    },
    {
        label: 'Meal',
        order: 5,
        description: 'For free. May include dairy and other allergens',
        id: 'meals',
        type: 'added',
        icon: 'food_drinks--cold_meals',
        details: { label: 'Learn more', route: 'details-snacks' },
        flight_details: { label: 'Learn more', route: 'flight-details-meals' }
    },
    {
        label: 'Fast track',
        description: 'All passengers can get faster through security',
        id: 'fasttrack',
        order: 6,
        type: 'added',
        flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
        icon: 'plane_related--fast_track',
        details: { label: 'Learn more', route: 'details-fast_track' }
    },
    {
        label: 'Free changes',
        description: 'Schedule or date changes allowed',
        type: 'added',
        icon: 'airport--changes',
        details: { label: 'Learn more', route: 'details-changes' },
        id: 'changes',
        order: 8,
        flight_details: { label: 'Learn more', route: 'flight-details-changes' },
    },
    {
        label: 'Choose your onboard meal',
        description: 'Choose onboard menu',
        type: 'extra',
        price: 0,
        secondary: false,
        secondary_on_mobile: false,
        action: { label: 'choose', route: 'ancillaries--special-meals' },
        icon: 'ancillaries--special_meals',
        name: 'meals',
        id: 'meals'
    },
    {
        label: 'Choose any seating area for free',
        description: 'Any seat free',
        type: 'extra',
        price: 0,
        secondary: false,
        secondary_on_mobile: false,
        action: { label: 'Choose', route: 'seatmap' },
        icon: 'plane_related--seat',
        name: 'Seats',
        id: 'seats'
    },
    {
        label: 'Extra bags from 47,00€',
        description: 'From 47,00€',
        type: 'extra',
        price: 0,
        secondary: false,
        secondary_on_mobile: false,
        action: { label: 'add', route: 'checked-bags' },
        icon: 'ancillaries--luggage',
        name: 'Checked bags',
        id: 'bags'
    },
    PREMIUM_CUSTOMER_CENTRE,
    PREMIUM_BOARDING,
    PRIORITY_CHECK_IN,
    {
        label: 'Refundable',
        type: 'added',
        details: { label: 'Learn more', route: 'details-refunds' },
        icon: 'money_related--refund',
        id: 'refunds',
        order: 99,
        flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
    }
].concat(BUSINESS_EXTRAS_SECONDARY_FEATURES);
export var TAP_MILES_GO_ECONOMY = [
    HAND_BAGGAGE,
    Object.assign({}, CHECKED_BAGGAGE, { amount: 1 }),
    {
        label: 'Standard seat reservation',
        order: 4,
        description: 'Free seat reservation in standard area',
        id: 'seats',
        type: 'added',
        icon: 'plane_related--seat',
        details: { label: 'Learn more', route: 'details-seat' },
        flight_details: { label: 'Learn more', route: 'flight-details-seat' }
    },
    {
        label: 'Fast track',
        description: 'All passengers can get faster through security',
        id: 'fasttrack',
        order: 5,
        type: 'added',
        flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
        icon: 'plane_related--fast_track',
        details: { label: 'Learn more', route: 'details-fast_track' }
    },
    {
        id: 'meals',
        label: 'Meal',
        order: 6,
        description: 'Meal not included',
        type: 'unavailable',
        details: { label: 'Learn more', route: 'details-snacks' },
        flight_details: { label: 'Learn more', route: 'flight-details-snacks' },
        icon: 'food_drinks--cold_meals'
    },
    Object.assign({}, PRIORITY_BAGGAGE, { type: 'unavailable' }),
    {
        label: 'Changes',
        icon: 'airport--changes',
        type: 'available',
        price: 100,
        id: 'changes',
        order: 8,
        flight_details: { label: 'Learn more', route: 'flight-details-changes' },
    },
    {
        label: 'Refundable',
        icon: 'money_related--refund',
        type: 'available',
        price: 10,
        id: 'refunds',
        order: 99,
        flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
    },
    {
        label: 'Choose a seating area from 12,00€',
        description: 'Seats from 12€',
        type: 'extra',
        price: 12,
        secondary: false,
        secondary_on_mobile: false,
        icon: 'plane_related--seat',
        action: { label: 'Choose', route: 'seatmap' },
        name: 'Seats',
        id: 'seats'
    },
    {
        label: 'Extra bags from 12,00€',
        description: 'from 22€',
        type: 'extra',
        price: 22,
        secondary: false,
        secondary_on_mobile: false,
        icon: 'ancillaries--luggage',
        action: { label: 'add', route: 'checked-bags' },
        name: 'Checked bags',
        id: 'bags'
    }
].concat(ECONOMY_EXTRAS_SECONDARY_FEATURES);
export var TAP_MILES_GO_ECONOMY_EXTRA = [
    HAND_BAGGAGE,
    Object.assign({}, CHECKED_BAGGAGE, { amount: 1 }),
    {
        label: 'Free Comfort seat',
        order: 4,
        description: 'Free seat reservation in Comfort area',
        id: 'seats',
        type: 'added',
        icon: 'plane_related--seat',
        details: { label: 'Learn more', route: 'details-seat' },
        flight_details: { label: 'Learn more', route: 'flight-details-seat' }
    },
    {
        label: 'Fast track',
        description: 'All passengers can get faster through security',
        id: 'fasttrack',
        order: 5,
        type: 'added',
        flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
        icon: 'plane_related--fast_track',
        details: { label: 'Learn more', route: 'details-fast_track' }
    },
    {
        label: 'Meal',
        order: 6,
        description: 'For free. May include dairy and other allergens',
        id: 'meals',
        type: 'added',
        icon: 'food_drinks--cold_meals',
        details: { label: 'Learn more', route: 'details-snacks' },
        flight_details: { label: 'Learn more', route: 'flight-details-meals' }
    },
    Object.assign({}, PRIORITY_BAGGAGE, { type: 'unavailable' }),
    {
        label: 'Changes',
        icon: 'airport--changes',
        type: 'available',
        price: 100,
        id: 'changes',
        order: 8,
        flight_details: { label: 'Learn more', route: 'flight-details-changes' },
    },
    {
        label: 'Refundable',
        icon: 'money_related--refund',
        type: 'available',
        price: 10,
        id: 'refunds',
        order: 99,
        flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
    },
    {
        label: 'Choose a seating area from 0€',
        description: 'Seats from 0€',
        type: 'extra',
        price: 12,
        secondary: false,
        secondary_on_mobile: false,
        icon: 'plane_related--seat',
        action: { label: 'Choose', route: 'seatmap' },
        name: 'Seats',
        id: 'seats'
    },
    {
        label: 'Extra bags from 12,00€',
        description: 'from 22€',
        type: 'extra',
        price: 22,
        secondary: false,
        secondary_on_mobile: false,
        icon: 'ancillaries--luggage',
        action: { label: 'add', route: 'checked-bags' },
        name: 'Checked bags',
        id: 'bags'
    }
].concat(ECONOMY_EXTRAS_SECONDARY_FEATURES);
export var TAP_MILES_GO_EXECUTIVE = [
    HAND_BAGGAGE,
    Object.assign({}, CHECKED_BAGGAGE, { amount: 2 }),
    {
        label: 'Free seat reservation',
        order: 4,
        description: 'In standard and preferred areas',
        id: 'seats',
        type: 'added',
        icon: 'plane_related--seat',
        details: { label: 'Learn more', route: 'details-seat' },
        flight_details: { label: 'Learn more', route: 'flight-details-seat' }
    },
    {
        label: 'Fast track',
        description: 'All passengers can get faster through security',
        id: 'fasttrack',
        order: 5,
        type: 'added',
        flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
        icon: 'plane_related--fast_track',
        details: { label: 'Learn more', route: 'details-fast_track' }
    },
    {
        label: 'Meal',
        order: 6,
        description: 'For free. May include dairy and other allergens',
        id: 'meals',
        type: 'added',
        icon: 'food_drinks--cold_meals',
        details: { label: 'Learn more', route: 'details-snacks' },
        flight_details: { label: 'Learn more', route: 'flight-details-meals' }
    },
    PRIORITY_BAGGAGE,
    {
        label: 'Changes',
        icon: 'airport--changes',
        type: 'available',
        price: 100,
        id: 'changes',
        order: 8,
        flight_details: { label: 'Learn more', route: 'flight-details-changes' },
    },
    {
        label: 'Refundable',
        icon: 'money_related--refund',
        type: 'available',
        price: 10,
        id: 'refunds',
        order: 99,
        flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
    },
    {
        label: 'Choose any seating area for free',
        description: 'Seats from 0€',
        type: 'extra',
        price: 12,
        secondary: false,
        secondary_on_mobile: false,
        icon: 'plane_related--seat',
        action: { label: 'Choose', route: 'seatmap' },
        name: 'Seats',
        id: 'seats'
    },
    {
        label: 'Choose your onboard meal',
        description: 'Choose onboard menu',
        type: 'extra',
        price: 0,
        secondary: false,
        secondary_on_mobile: false,
        action: { label: 'choose', route: 'ancillaries--special-meals' },
        icon: 'ancillaries--special_meals',
        name: 'meals',
        id: 'meals'
    },
    {
        label: 'Extra bags from 12,00€',
        description: 'from 22€',
        type: 'extra',
        price: 22,
        secondary: false,
        secondary_on_mobile: false,
        icon: 'ancillaries--luggage',
        action: { label: 'add', route: 'checked-bags' },
        name: 'Checked bags',
        id: 'bags'
    }
].concat(BUSINESS_EXTRAS_SECONDARY_FEATURES);
export var STAR_ALLIANCE_ECONOMY = [
    HAND_BAGGAGE,
    Object.assign({}, CHECKED_BAGGAGE, { amount: 1 }),
    {
        label: 'Fast track',
        id: 'fasttrack',
        order: 7,
        type: 'unavailable',
        flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
        icon: 'plane_related--fast_track',
        details: { label: 'Learn more', route: 'details-fast_track' }
    },
    {
        label: 'Changes',
        icon: 'airport--changes',
        type: 'available',
        price: 100,
        id: 'changes',
        order: 8,
        flight_details: { label: 'Learn more', route: 'flight-details-changes' },
    },
    {
        label: 'Refundable',
        icon: 'money_related--refund',
        type: 'available',
        price: 10,
        id: 'refunds',
        order: 99,
        flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
    },
    {
        label: 'Meal',
        order: 5,
        description: 'For free. May include dairy and other allergens',
        id: 'meals',
        type: 'added',
        icon: 'food_drinks--cold_meals',
        details: { label: 'Learn more', route: 'details-snacks' },
        flight_details: { label: 'Learn more', route: 'flight-details-snacks' }
    },
];
export var STAR_ALLIANCE_BUSINESS = [
    HAND_BAGGAGE,
    Object.assign({}, CHECKED_BAGGAGE, { amount: 1 }),
    {
        label: 'Fast track',
        description: 'All passengers can get faster through security',
        id: 'fasttrack',
        order: 7,
        type: 'added',
        flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
        icon: 'plane_related--fast_track',
        details: { label: 'Learn more', route: 'details-fast_track' }
    },
    {
        label: 'Changes',
        icon: 'airport--changes',
        type: 'available',
        price: 100,
        id: 'changes',
        order: 8,
        flight_details: { label: 'Learn more', route: 'flight-details-changes' },
    },
    {
        label: 'Refundable',
        icon: 'money_related--refund',
        type: 'available',
        price: 10,
        id: 'refunds',
        order: 99,
        flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
    },
    {
        label: 'Business Meal',
        order: 5,
        description: 'For free. May include dairy and other allergens',
        id: 'meals',
        type: 'added',
        icon: 'food_drinks--cold_meals',
        details: { label: 'Learn more', route: 'details-snacks' },
        flight_details: { label: 'Learn more', route: 'flight-details-snacks' }
    },
];
export var STAR_ALLIANCE_FIRST = [
    HAND_BAGGAGE,
    Object.assign({}, CHECKED_BAGGAGE, { amount: 2 }),
    {
        label: 'Fast track',
        description: 'All passengers can get faster through security',
        id: 'fasttrack',
        order: 7,
        type: 'added',
        flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
        icon: 'plane_related--fast_track',
        details: { label: 'Learn more', route: 'details-fast_track' }
    },
    {
        label: 'Changes',
        icon: 'airport--changes',
        type: 'available',
        price: 100,
        id: 'changes',
        order: 8,
        flight_details: { label: 'Learn more', route: 'flight-details-changes' },
    },
    {
        label: 'Refundable',
        icon: 'money_related--refund',
        type: 'available',
        price: 10,
        id: 'refunds',
        order: 99,
        flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
    },
    {
        label: 'First Class Meal',
        order: 5,
        description: 'For free. May include dairy and other allergens',
        id: 'meals',
        type: 'added',
        icon: 'food_drinks--cold_meals',
        details: { label: 'Learn more', route: 'details-snacks' },
        flight_details: { label: 'Learn more', route: 'flight-details-snacks' }
    },
];
export var getBrands = function (options) {
    if (options === void 0) { options = { brands: false }; }
    var brandsList = [
        {
            label: 'Economy',
            label_sufix: 'from',
            brands: [
                { name: 'discount' },
                { name: 'basic' },
                { name: 'classic' },
                { name: 'plus' }
            ]
        },
        {
            label: 'Business',
            label_sufix: 'from',
            brands: [
                { name: 'executive' },
                { name: 'top-executive' }
            ]
        },
        {
            label: 'Economy/Executive',
            label_sufix: 'from',
            brands: [
                { name: 'milesgo-economy' },
                { name: 'miles&go-extra' },
                { name: 'miles&go-executive' }
            ]
        },
        {
            label: 'Economy/Business',
            label_sufix: 'from',
            brands: [
                { name: 'star_alliance-economy' },
                { name: 'star_alliance-business' },
                { name: 'star_alliance-first' }
            ]
        }
    ];
    if (options.brands) {
        return brandsList.reduce(function (acc, cur) { cur.brands.map(function (c) { return acc.push(c.name); }); return acc; }, []);
    }
    return brandsList;
};
export var getBrandFeatures = function (brand, options, order) {
    if (options === void 0) { options = { NO_PREMIUM_FEATURES: false }; }
    if (order === void 0) { order = true; }
    // return this.EXAMPLE_FEATURES;
    var featureList = [];
    brand = brand ? brand.toLowerCase() : '';
    switch (brand) {
        case 'discount':
            featureList = !options.NO_PREMIUM_FEATURES ? DISCOUNT_FEATURES : [].concat(DISCOUNT_FEATURES, NO_PREMIUM_FEATURES);
            break;
        case 'basic':
            featureList = !options.NO_PREMIUM_FEATURES ? BASIC_FEATURES : [].concat(BASIC_FEATURES, NO_PREMIUM_FEATURES);
            break;
        case 'classic':
            featureList = !options.NO_PREMIUM_FEATURES ? CLASSIC_FEATURES : [].concat(CLASSIC_FEATURES, NO_PREMIUM_FEATURES);
            break;
        case 'plus':
            featureList = !options.NO_PREMIUM_FEATURES ? PLUS_FEATURES : [].concat(PLUS_FEATURES, NO_PREMIUM_FEATURES);
            break;
        case 'executive':
            featureList = EXECUTIVE_FEATURES;
            break;
        case 'top-executive':
            featureList = TOP_EXECUTIVE_FEATURES;
            break;
        case 'miles&go-economy':
            featureList = TAP_MILES_GO_ECONOMY;
            break;
        case 'miles&go-extra':
            featureList = TAP_MILES_GO_ECONOMY_EXTRA;
            break;
        case 'miles&go-executive':
            featureList = TAP_MILES_GO_EXECUTIVE;
            break;
        case 'star_alliance-economy':
            featureList = STAR_ALLIANCE_ECONOMY;
            break;
        case 'star_alliance-business':
            featureList = STAR_ALLIANCE_BUSINESS;
            break;
        case 'star_alliance-first':
            featureList = STAR_ALLIANCE_FIRST;
            break;
        default:
            featureList = DEFAULT_FEATURES;
            break;
    }
    if (order) {
        featureList = featureList.slice().sort(function (a, b) { return a.order && b.order && parseFloat(a.order) - parseFloat(b.order); });
    }
    return featureList;
};
export var INDRA_getFeatureForTAC = function (basic_ancillary_code, brand, redAndGreenEligibleRoute, haulType, inDirectFlight) {
    var feature;
    switch (basic_ancillary_code) {
        case BASIC_ANCILLARY_CODES_MILES:
            feature = MILES;
            break;
        case BASIC_ANCILLARY_CODES_HAND_BAGGAGE:
            feature = HAND_BAGGAGE;
            break;
        case BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE:
            feature = CHECKED_BAGGAGE;
            break;
        case BASIC_ANCILLARY_CODES_SEAT_RESERVATION:
            feature = SEATS;
            break;
        case BASIC_ANCILLARY_CODES_MEALS:
            if ((brand === BRAND_CODE_EXECUTIVE || brand === BRAND_CODE_TOP_EXECUTIVE || brand === BRAND_CODE_AWARD_EXECUTIVE) ||
                (redAndGreenEligibleRoute) || (haulType === FLIGHT_HAUL_TYPE_LONG) || inDirectFlight) {
                feature = MEALS;
            }
            else if (!brand || redAndGreenEligibleRoute === null || !haulType) {
                // assume meals if these information are not provided, or if provided as NULL
                feature = MEALS;
            }
            else {
                // feature = SNACKS;
                //TO DO: IF THERE WILL BE BA_SNACK RETURNED BY BE, THE CONDITION FOR MEALS CAN BE DELETED SINCE SNACK HAS ITS OWN CASE
                feature = MEALS;
            }
            break;
        case BASIC_ANCILLARY_CODES_SNACK:
            feature = SNACKS;
            break;
        case BASIC_ANCILLARY_CODES_PREMIUM_BOARDING:
            feature = PREMIUM_BOARDING;
            break;
        case BASIC_ANCILLARY_CODES_FASTTRACK:
            feature = FASTTRACK;
            break;
        case BASIC_ANCILLARY_CODES_FLIGHT_CHANGES:
            feature = CHANGES;
            break;
        case BASIC_ANCILLARY_CODES_FLIGHT_REFUNDS:
            feature = REFUNDS;
            break;
        case BASIC_ANCILLARY_CODES_PREMIUM_CHECKIN:
            feature = PRIORITY_CHECK_IN;
            break;
        case BASIC_ANCILLARY_CODES_PREMIUM_CUSTOMER_CENTER:
            feature = PREMIUM_CUSTOMER_CENTRE;
            break;
        case BASIC_ANCILLARY_CODES_LOUNGE:
            feature = DETAILS_LOUNGE;
            break;
        case BASIC_ANCILLARY_CODES_KIOSK:
            feature = DIGITAL_KIOSK;
            break;
        case BASIC_ANCILLARY_CODES_PRIORITY_BAGGAGE:
            feature = PRIORITY_BAGGAGE;
            break;
        case BASIC_ANCILLARY_CODES_PREMIUM_BAGGAGE:
            feature = PREMIUM_BAGGAGE;
            break;
        case BASIC_ANCILLARY_CODES_FLIGHT_CANCELLATION:
            feature = CANCELLATIONS;
            break;
    }
    return feature;
};
export var INDRA_getCheckedBaggageDetails = function (ancillary_code) {
    var details;
    switch (ancillary_code) {
        case SSR_CODE_BAGGAGE_FIRST_BAG:
            details = CHECKED_BAGGAGE_DETAILS[SSR_CODE_BAGGAGE_FIRST_BAG];
            break;
        case SSR_CODE_BAGGAGE_SECOND_BAG:
            details = CHECKED_BAGGAGE_DETAILS[SSR_CODE_BAGGAGE_SECOND_BAG];
            break;
        case SSR_CODE_BAGGAGE_ADDITIONAL_BAG:
            details = CHECKED_BAGGAGE_DETAILS[SSR_CODE_BAGGAGE_ADDITIONAL_BAG];
            break;
        case SSR_CODE_BAGGAGE_FIRST_BAG_X2:
            details = CHECKED_BAGGAGE_DETAILS[SSR_CODE_BAGGAGE_FIRST_BAG_X2];
            break;
        case SSR_CODE_BAGGAGE_FIRST_BAG_X3:
            details = CHECKED_BAGGAGE_DETAILS[SSR_CODE_BAGGAGE_FIRST_BAG_X3];
            break;
        case SSR_CODE_BAGGAGE_32_BAG_X2:
            details = CHECKED_BAGGAGE_DETAILS[SSR_CODE_BAGGAGE_32_BAG_X2];
            break;
        case SSR_CODE_BAGGAGE_32_BAG_X3:
            details = CHECKED_BAGGAGE_DETAILS[SSR_CODE_BAGGAGE_32_BAG_X3];
            break;
    }
    return details;
};
// TODO clean up TAC features
